import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import "./Footer.scss"

interface FooterBlockProps {
  canScroll?: string;
}

const FooterBlock = ({ canScroll }: FooterBlockProps) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  return (
    <footer className={`background-grad-blue disable-selection footer ${canScroll}`}>
      <div className="footer-block background-grad-copper">
        <div className="footer-content">
        <img
          className="footer-logo"
          alt="Solvize dark logo"
          src="/images/logo/solvize-blue.svg"
          onClick={(e) => {
            navigate(`/`);
            e.stopPropagation();
          }}
        />

        <p className="footer-text">
          {t('footer.madeBy')}
        </p>
        <p className="footer-text">
          {t('footer.thesis')}
        </p>
        </div>
      </div>
    </footer>
  );
};

export default FooterBlock;
